<template>
    <div
        class="fixed w-full"
        :style="{
            top: `${store.headerHeight}px`,
            height: `calc(100dvh - ${store.headerHeight}px)`,
        }"
    >
        <!-- <div class="w-full"> -->
        <ClientOnly>
            <div
                class="mx-0 h-full w-full border-t border-black-text bg-white pt-2 2xl:mx-10 2xl:w-[calc(100%_-_5rem)] 2xl:py-4"
            >
                <slot />
            </div>
        </ClientOnly>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()
</script>

<style></style>
